export default {
  getOppregistrationState (state) {
    return state.oppregistration
  },
  getSelectedAwsServices (state) {
    let selectedAwsServices = []
    if (state.workloadForm.fields.Workload_Services_Storage == '1') {
      selectedAwsServices.push('Storage')
    }
    if (state.workloadForm.fields.Workload_Services_Database == '1') {
      selectedAwsServices.push('Database')
    }
    if (state.workloadForm.fields.Workload_Services_App_services == '1') {
      selectedAwsServices.push('App Services')
    }
    if (state.workloadForm.fields.Workload_Services_Compute == '1') {
      selectedAwsServices.push('Compute')
    }
    if (state.workloadForm.fields.Workload_Services_Network == '1') {
      selectedAwsServices.push('Network')
    }
    return selectedAwsServices
  }
}
